import React, { useState, useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "./Pages/Home";
import Mint from "./Pages/Mint";
import Verify from "./Pages/Verify";
import Search from "./Pages/Search";
import Error from "./Pages/Error";
import Navbar from "./Navbar";
import Footer from "./Footer";
import Recovery from "./Pages/Recovery";

const App = () => {
  // dark and light mode
  // const [theme, setTheme] = useState("light");
  // const toggleTheme = () => {
  //   setTheme(theme === "light" ? "dark" : "light");
  // };

  // useEffect(() => {
  //   localStorage.setItem("theme", theme);
  // }, [theme]);

  return (
    <BrowserRouter>
      <Navbar />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="mint" element={<Mint />} />
        <Route path="verify" element={<Verify />} />
        <Route path="search" element={<Search />} />
        <Route path="recovery" element={<Recovery />} />
        <Route path="*" element={<Error />} />
      </Routes>
      <Footer />
    </BrowserRouter>
  );
};

export default App;
